import type React from 'react';

import type { RecommendedGroup } from 'src/app/pages/starterDashboardV2/shared/types';

import type { RecommendedGroupWithPlatform } from '../../../../hooks/useSharingTools/types';
import { RecommendedGroupCardItem } from '../RecommendedGroupCardItem';

import { mapRecommendedGroupToGroupData } from './helpers';

export const RecommendedGroupsCardsContainer: React.FC<{
	groups: readonly RecommendedGroupWithPlatform[];
	onFacebookGroupClick?: (group: RecommendedGroup) => void;
	onRedditGroupClick?: (group: RecommendedGroup) => void;
}> = ({ groups, onFacebookGroupClick, onRedditGroupClick }) => {
	return (
		<div className="flex h-full w-full items-center justify-center gap-2.5 md:gap-4">
			{groups.map(({ group, platform }) => {
				const groupData = mapRecommendedGroupToGroupData(group, platform);
				const onClickHandler = platform === 'facebook' ? onFacebookGroupClick : onRedditGroupClick;
				const handleClick = onClickHandler ? () => onClickHandler(group) : undefined;
				return (
					<RecommendedGroupCardItem
						data-qa={`recommended-group-card-${platform}-${group.name}`}
						key={`${platform}-${group.name}`}
						group={groupData}
						platform={platform}
						onClick={handleClick}
					/>
				);
			})}
		</div>
	);
};
